<template>
  <div>
    <Header />
    <div class="userPage">
      <div class="c h">
        <div class="userLeft fl">
          <div class="photo">
            <img v-if="loginUserInfo && loginUserInfo.user_open_data && loginUserInfo.user_open_data.weixin && loginUserInfo.user_open_data.weixin.photo" :src="loginUserInfo.user_open_data.weixin.photo" />
            <img v-else src="../../assets/user.png" />
            <!-- <p class="userName">{{$store.state.login.userInfo.username}}，{{$store.state.login.userInfo.type == 1 ? '同学' : '老师'}}</p> -->
            <p class="userName">{{ loginUserInfo && loginUserInfo.name }}</p>
          </div>
          <ul class="Userlist">
            <li>
              <p><span class="iconfont iconkecheng"></span> 课程学习</p>
              <dd>
                <router-link class="dd" :to="`/${school_code}/user/myClass`">
                  我的课程
                  <span class="iconfont iconsanjiaoright fr"></span>
                </router-link>
              </dd>
              <dd>
                <router-link class="dd" :to="`/${school_code}/user/studyRecord`">
                  学习记录
                  <span class="iconfont iconsanjiaoright fr"></span>
                </router-link>
              </dd>
              <dd>
                <router-link class="dd" :to="`/${school_code}/user/myNote`">
                  我的笔记
                  <span class="iconfont iconsanjiaoright fr"></span>
                </router-link>
              </dd>
              <dd>
                <router-link class="dd" :to="`/${school_code}/user/myCertificate`">
                  我的证书
                  <span class="iconfont iconsanjiaoright fr"></span>
                </router-link>
              </dd>
              <dd>
                <router-link class="dd" :to="`/${school_code}/user/myPractice`">
                  我的练习
                  <span class="iconfont iconsanjiaoright fr"></span>
                </router-link>
              </dd>
              <dd>
                <router-link class="dd" :to="`/${school_code}/user/myAssess`">
                  我的测评
                  <span class="iconfont iconsanjiaoright fr"></span>
                </router-link>
              </dd>
              <dd>
                <router-link class="dd" :to="`/${school_code}/user/MyStudy`">
                  学习数据
                  <span class="iconfont iconsanjiaoright fr"></span>
                </router-link>
              </dd>
            </li>

          </ul>
        </div>
        <div class="userRight fr" :class="[$route.path.indexOf('MyStudy')>-1?'noborder':'']">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import "./user.less";
import { mapActions, mapState } from "vuex";
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer";
export default {
  name: "User",
  components: {
    Header: Header,
    Footer: Footer
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode")
    };
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    })
  },
  created () {
    // console.log(this.$route.path);
  }
};
</script>

<style scoped>
.main-top {
  background-color: #fff !important;
  background: #fff !important;
}
.menu-my-certificate > p {
  display: none;
}
.menu-my-certificate dd {
  height: 50px !important;
  margin: 5px 0;
}
.menu-my-certificate dd:hover {
  border-radius: 2px;
  background: #fafafa;
}
.menu-my-certificate dd a {
  font-size: 18px;
  font-family: Microsoft YaHei;
  color: #4c4c4c !important;
  height: 50px !important;
  line-height: 50px !important;
  position: relative;
}
.menu-my-certificate dd a::before {
  content: '';
  background: url('../../assets/site/user/icon-book.png');
  width: 19px;
  height: 21px;
  display: inline-block;
  position: absolute;
  top: 15px;
  left: 37px;
}
.menu-my-certificate .router-link-active::before {
  content: '';
  background: url('../../assets/site/user/icon-book-active.png');
  width: 19px;
  height: 21px;
  display: inline-block;
  position: absolute;
  top: 15px;
  left: 37px;
}
.menu-my-certificate .iconfont.iconsanjiaoright::before {
  content: '';
}
.noborder {
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
}
</style>
